import { useState, FormEvent } from "react";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { Box, Button, TextField, Typography, Paper, Alert, CircularProgress, Link } from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { useAuth } from "@/context/AuthContext";

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState(""); const [email, setEmail] = useState(""); const [password, setPassword] = useState("");
  const [error, setError] = useState(""); const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { await register(name, email, password); nav("/household"); }
    catch (err: any) { setError(err.response?.data?.error || "Erreur lors de l'inscription."); }
    finally { setLoading(false); }
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "grey.100", p: 2 }}>
      <Paper elevation={3} sx={{ p: { xs: 3, sm: 5 }, width: "100%", maxWidth: 420, borderRadius: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 3 }}>
          <AccountBalanceWalletIcon color="primary" sx={{ fontSize: 48, mb: 1 }} />
          <Typography variant="h5" fontWeight={700}>Créer un compte</Typography>
        </Box>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField label="Prénom" value={name} onChange={e => setName(e.target.value)} required fullWidth />
          <TextField label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} required fullWidth />
          <TextField label="Mot de passe" type="password" value={password} onChange={e => setPassword(e.target.value)} required fullWidth inputProps={{ minLength: 6 }} />
          <Button type="submit" variant="contained" size="large" fullWidth disabled={loading} sx={{ mt: 1, py: 1.5, fontWeight: 600 }}>
            {loading ? <CircularProgress size={24} color="inherit" /> : "Créer mon compte"}
          </Button>
        </Box>
        <Typography variant="body2" align="center" sx={{ mt: 3 }}>
          Déjà un compte ? <Link component={RouterLink} to="/login" fontWeight={600}>Se connecter</Link>
        </Typography>
      </Paper>
    </Box>
  );
}
